import { useMemo } from 'react'
import { createLocUpgradeLevels, getAvailableCash, getAvailableCashSources } from '@prometheus/utils'
import { Sheet } from '@prometheus/types'
import { useSelector } from '../../../hooks/useSelector'

/**
 * How much cash the player could raise right now by selling bonds, drawing on
 * the line of credit and taking planet loans — the same sources, and the same
 * maths, the server's purchase assist uses.
 *
 * Lets a buy control promise "Withdraw Cash & Purchase" only when the
 * withdrawal would actually go through; otherwise the control stays disabled
 * rather than sending the player into a refusal.
 */
export function useAvailableCash() {
  const sheet = useSelector(s => s.game.sheet)
  const loc_max_upgrades = useSelector(s => s.game.options?.loc_max_upgrades)

  return useMemo(() => {
    if (!sheet) {
      return { available: 0, sources: { bonds: 0, loc: 0, planet_loans: 0 } }
    }
    const ladder = loc_max_upgrades?.length ? createLocUpgradeLevels(loc_max_upgrades) : []
    const loc_max = (ladder[sheet.loc?.max_level || 0]?.max || 0) + (sheet.loc?.max_bonuses || 0)

    return {
      available: getAvailableCash(sheet as Sheet, loc_max),
      sources: getAvailableCashSources(sheet as Sheet, loc_max),
    }
  }, [sheet, loc_max_upgrades])
}

export default useAvailableCash
